import { Skeleton } from "@/components/ui/skeleton";

/**
 * RouteLoadingSkeleton - Loading state for lazy-loaded routes
 * Provides a branded loading experience matching the app's gradient background
 */
export default function RouteLoadingSkeleton() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 p-4 sm:p-8">
      <div className="max-w-7xl mx-auto space-y-6">
        {/* Header skeleton */}
        <div className="space-y-2">
          <Skeleton className="h-10 w-64" />
          <Skeleton className="h-4 w-48" />
        </div>

        {/* Content cards skeleton */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <Skeleton className="h-32" />
          <Skeleton className="h-32" />
          <Skeleton className="h-32" />
          <Skeleton className="h-32" />
        </div>

        {/* Main content skeleton */}
        <Skeleton className="h-96" />
      </div>
    </div>
  );
}
